import React from 'react';
function ShoppingCart({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10 21a1 1 0 100-2 1 1 0 000 2zM18 21a1 1 0 100-2 1 1 0 000 2zM3 4h3.273l2.192 10.712c.075.368.28.699.58.934.299.236.673.36 1.057.354h7.953a1.66 1.66 0 001.057-.354c.3-.235.504-.566.579-.934L21 8H7.09"
      />
    </svg>
  );
}

export default ShoppingCart;
